import React, { useCallback, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import { makeStyles } from "@material-ui/core/styles";

import Loading from "../../../../common/Loading";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";

import Button from "components/CustomButtons/Button";
import { InputAdornment } from "@material-ui/core";

const validationSchema = Yup.object().shape({
  source: Yup.string().required("Recipient Name and Address is required"),
  description: Yup.string().required("Purpose is required"),
  amount: Yup.number().min(0, "Min value 0.").required("Amount is required")
});

const useStyles = makeStyles(theme => ({
  dialogActions: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2)
  },
  marginBottom: {
    marginBottom: theme.spacing(3)
  },
  marginRight: {
    marginRight: theme.spacing(3)
  },
  content: {
    minHeight: 100
  }
}));

const defaultValues = {
  recipient: "",
  purpose: "",
  amount: 0
};

const ScholarshipDialog = ({ open, data, onClose, onCreate, onUpdate }) => {
  const classes = useStyles();

  const { item, isCreating } = data;

  const [isDirty, setDirty] = useState(false);

  const initialValues =
    Object.keys(item || {}).length > 0 ? item : defaultValues;

  const handleSubmit = useCallback(
    values => {
      setDirty(true);
      isCreating ? onCreate(values) : onUpdate(values);
    },
    [isCreating]
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Chapter Financial Information</DialogTitle>
      <DialogContent>
        <Grid container direction="column">
          <Typography className={classes.marginBottom}>
            <strong>
              {isCreating ? "Add" : "Edit"} Scholarship Information
            </strong>
          </Typography>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              values,
              touched,
              errors,
              handleChange,
              handleBlur,
              isValid
            }) => (
              <Form noValidate autoComplete="off">
                <Grid item>
                  <Grid container spacing={2} className={classes.content}>
                    <Grid item md={5} sm={6} xs={12}>
                      <TextField
                        error={Boolean(touched.source && errors.source)}
                        helperText={touched.source && errors.source}
                        label="Recipient name and address"
                        variant="outlined"
                        name="source"
                        fullWidth
                        value={values.source}
                        onChange={handleChange}
                        multiline
                        rows={5}
                      />
                    </Grid>
                    <Grid item md={5} sm={6} xs={12}>
                      <TextField
                        error={Boolean(
                          touched.description && errors.description
                        )}
                        helperText={touched.description && errors.description}
                        label="Purpose"
                        variant="outlined"
                        name="description"
                        fullWidth
                        value={values.description}
                        onChange={handleChange}
                        multiline
                        rows={5}
                      />
                    </Grid>
                    <Grid item md={2} sm={12} xs={12}>
                      <TextField
                        error={Boolean(touched.amount && errors.amount)}
                        helperText={
                          touched.amount &&
                          errors.amount &&
                          "Enter a valid number."
                        }
                        fullWidth
                        label="Amount"
                        variant="outlined"
                        name="amount"
                        value={values.amount}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          )
                        }}
                        onChange={handleChange}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <div className={classes.dialogActions}>
                  {isDirty ? (
                    <Loading />
                  ) : (
                    <>
                      <Button
                        className={classes.marginRight}
                        color="success"
                        variant="contained"
                        type="submit"
                      >
                        Submit
                      </Button>
                      <Button
                        color="danger"
                        variant="contained"
                        onClick={onClose}
                      >
                        Cancel
                      </Button>
                    </>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ScholarshipDialog;
